








































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Meta } from '@sophosoft/vue-meta-decorator'

import { TableItem, TableHeaderItem } from '@/utils/types'

import { Profile, Company, Contact, Badge } from '@/store/modules/lib'

import ContactList from '@/components/lfs/Company/ContactList.vue'
import BadgeEditModal from '@/components/lfs/Badges/BadgeEditModal.vue'
import VueQrcode from 'vue-qrcode'
import ContactModal from '@/components/lfs/Company/CompanyEditModal.vue'
import IEdit from '@/components/icons/IEdit.vue'
import IClose from '@/components/icons/IClose.vue'
import Tooltip from '@/components/UI/Tooltip.vue';
import Modal from "@/components/UI/Modal.vue";
import {urlWithContour} from "@/helpers/currentContour";


  interface IStandLink {
    title: string
    link: string
  }

const profile = namespace('profile')
const roistat = namespace('roistat')

@Component({
  components: {
    'vue-qr-code': VueQrcode,
    ContactList,
    'c-badge-edit-modal': BadgeEditModal,
    'c-contact-modal': ContactModal,
    'i-edit': IEdit,
    'i-close': IClose,
    Tooltip,
    Modal
  }
})
export default class ProfileInfo extends Vue {
  @roistat.Action('sendEvent') protected sendEvent:any

  deleteDlgState:boolean = false

  @profile.Action('deleteBadge') protected deleteBadge:any
  @profile.Mutation('setProfile') protected setProfile: any

  async deleteStandist(){
    await this.deleteBadge(this.currentBadge.id)
    this.deleteDlgState = false
    let params = [
      {
        "name": "“Профиль”: Действие “Удаление бейджа” в блоке Бейджи",
        "data": {
          "company": this.userCompany.title
        }
      }
    ]
    this.sendEvent(params)
  }

  @Meta
  getMetaInfo() {
    return {
      title: `LeadFrog - Профиль`,
    }
  }

  protected dlgTitleBarcode: string = ''
  protected dlgCode: string = ''
  protected barcodeDlgState: boolean = false

  protected openBarcodeDlg (item: TableItem): void {
    this.dlgTitleBarcode = `${item.last} ${item.first}`
    this.dlgCode = item.barcode
    this.barcodeDlgState = true
  }

  @profile.State('userCompany') protected userCompany: any
  @profile.State('profiles') protected badges: any
  @profile.Getter('standCompanies') protected standCompanies!: Company[]

  protected helpDlg: boolean = false

  protected applyHelp (): void {
    localStorage.setItem('profile-help-close', '1')

    this.helpDlg = false
  }

  protected editBadgeDlgState: boolean = false
  protected editContactDlgState: boolean = false
  protected currentBadge: any = {}
  protected headers: TableHeaderItem[] = []

  @Watch('currentBadge')
  isCurrentBadgeEdit (newValue: Badge): void {
    const links = newValue.promo
    const badgeId = newValue.id

    this.$store.commit('profile/setBadgeLinks', {
      badgeId,
      links
    })
  }

  protected get standLinks (): IStandLink[] {
    return this.standCompanies.map((company: Company) => {
      return {
        title: company.standTitle,
        link: `${urlWithContour()}/c/${company._id}`
      }
    })
  }

  protected get profileCompany (): Company {
    return this.$store.getters['profile/userCompany']
  }

  protected get items (): TableItem[] {
    return this.badges.map((badge: Profile) => {
      return {
        id: badge._id,
        barcode: badge.barcode,
        first: badge.name.first,
        last: badge.name.last,
        position: badge.position,
        about: badge.about,
        contacts: badge.contacts,
        locations: badge.locations,
        promo: badge.promo
      }
    })
  }

  protected getCompanyContact (type: string) {
    if (this.userCompany != null) {
      let contact = this.userCompany.contacts.filter(
        (contact: Contact) => contact.type === type
      )

      if (contact.length > 0) return contact[0].value
    }

    return ''
  }

  protected mounted (): void {
    if (!localStorage.getItem('profile-help-close')) {
      this.helpDlg = true
    }
  }

  protected beforeMount (): void {
    this.headers = [
      { value: 'first', text: 'Имя' },
      { value: 'last', text: 'Фамилия' },
      { value: 'position', text: 'Должность' }
    ]
  }

  openDlgEditProfile (item : any): void {
    this.currentBadge = item
    this.setProfile(item.id)
    this.editBadgeDlgState = true
  }

  onChange (val : any): void {
    this.currentBadge = { ...this.currentBadge, ...val }
  }

  onChangeLocations (val : any): void {
    this.currentBadge.locations = val
  }

  onDelete (val : any): void {
    this.currentBadge = val
  }
}
